<template>
  <div v-show="HasShowForm" @keyup.enter="OnKeyUpEnter">
    <div class="row" v-if="!hasMinimizado">
      <div class="col-md-12">
        <div class="card card-bottom-radius-8">
          <div v-if="!hideHead" class="card-header text-third"  >

            <strong><i v-if="!showEdit" class="icon-edit"></i><i v-if="showEdit" class="fas fa-edit"></i></strong>
            <strong><i v-if="!showSearchIcon" class="icon-note"></i><i v-if="showSearchIcon" class="fa fa-search"></i>&nbsp; {{this.title}}</strong>
            <slot name="header"></slot>
            <div class="card-actions" >
              <slot name="action"></slot>
              <a href="javascript:void(0);" v-show="HasSettings" @click="$emit('Settings')" v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonSettings" placement="left">
                <i class="fas fa-cogs text-third"></i>
              </a>
              <a href="javascript:void(0);" v-show="HasMinimize" @click="changeMinimizado" v-b-tooltip.hover :title="'Minimizar'" placement="left">
                <i class="fas fa-arrow-left" style="color:#008148; cursor:pointer"></i>
              </a>
              <a :href="helpUrl" v-show="HasHelp" target="_blank" v-b-tooltip.hover :title="$lang.Common.Tooltip.LearnToUse" placement="left">
                <i class="far fa-question-circle text-third"></i>
              </a>
              <a href="javascript:void(0);" v-show="HasReload" @click="$emit('Reload')" v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonUpdate" placement="left">
                <i class="fas fa-sync-alt text-third"></i>
              </a>
            </div>
          </div>
          <div class="card-block">
            <form autocomplete="off" role="presentation" @submit.stop.prevent="">
              <slot></slot>
            </form>
          </div>
            <div v-if="ShowFooterImbo" class="d-flex align-items-center flex-column mt-5 mb-5">
              <button v-on:click="$emit('Search')" v-if="!HiddenFooterImbo" class="w-75" onMouseOver="this.style.backgroundColor='rgb(3 172 97)'" onMouseOut="this.style.backgroundColor='#008148'" style="background-color:#008148;border-radius:5px;color:white;height:35px;border: 1px solid #CED4DA"><i class="fa fa-search mr-2"></i>BUSCAR</button>
              <button v-on:click="$emit('Clear')" v-if="!HiddenFooterImbo" class="w-75 mt-2" style="background-color:#F5F5F5;border-radius:5px;color:grey;height:35px;border: 1px solid #CED4DA">LIMPAR FILTRO</button>
            </div>
          <div v-if="!ShowFooterImbo"  class="card-footer card-bottom-radius-8">
            <div class="row">
              <div class="col-md-8">
                <button type="button" class="btn btn-third btn-sm" v-show="HasButtonBackIcon" v-on:click="$emit('Back')" v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonBack"><i class="fas fa-arrow-circle-left"></i></button>
                <button type="button" class="btn btn-third btn-sm" v-show="HasButtonNew" v-on:click="$emit('New')" v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonNew"><i class="fas fa-plus-circle"></i> {{$lang.Common.Buttons.New}}</button>
                <button type="button" class="btn btn-third btn-sm" v-show="HasButtonSearch" v-on:click="$emit('Search')" v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonSearch"><i class="fa fa-search"></i> {{$lang.Common.Buttons.Search}}</button>&nbsp;
                <button type="button" class="btn btn-third btn-sm" v-show="HasButtonSearchIcon" v-on:click="$emit('Search')" v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonSearch"><i class="fa fa-search"></i></button>&nbsp;
                <button type="button" class="btn btn-third btn-sm" v-show="HasButtonSave" v-on:click="$emit('Save')" v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonSave"><i class="fa fa-check-circle"></i> {{TextButtonSave}}</button>&nbsp;
                <button type="button" class="btn btn-third btn-sm" v-show="HasButtonSaveIcon" v-on:click="$emit('Save')" v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonSave"><i class="fa fa-save"></i></button>&nbsp;
                <button type="button" class="btn btn-default btn-sm text-secondary" v-show="HasButtonClear" v-on:click="$emit('Clear')" v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonClear"><i class="fa fa-minus-circle"></i> {{$lang.Common.Buttons.Clear}}</button>
                <button type="button" class="btn btn-default btn-sm text-secondary" v-show="HasButtonClearIcon" v-on:click="$emit('Clear')" v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonClear"><i class="fa fa-minus-circle"></i></button>
                <slot name="button"></slot>
              </div>
              <div class="col-md-4 text-right">
                <button type="button" class="btn btn-third btn-sm" v-show="HasButtonBack" v-on:click="$emit('Back')" v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonBack"><i class="fas fa-undo"></i> <span class="d-md-down-none">{{$lang.Common.Buttons.Back}}</span></button>&nbsp;
                <button type="button" class="btn btn-fourth btn-sm" v-show="HasButtonExport" v-on:click="$emit('Export')" v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonExportExcel"><i class="fa fa-download"></i> <span class="d-md-down-none">{{$lang.Common.Buttons.ExportExcel}}</span></button>&nbsp;
                <slot name="FooterButtonLeft"></slot>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <slot name="slotminimized"></slot>
    </div>
    <!-- <RequiredFieldBlock :showMessage="showTipFooter" :message="messageTipFooter" :type="messageTypeTipFooter" /> -->
  </div>
</template>
<script>
import RequiredFieldBlock from './RequiredFieldBlock'

export default {
  name: 'Forms',
  data () {
    return {
      showForm: true,
      hasMinimizado: false
    }
  },
  props: {
    title: {
      type: String,
      required: true,
      default: function () {
        return this.$lang.TitleForms
      }
    },
    showHelp: {
      type: Boolean,
      default: false
    },
    helpUrl: {
      type: String,
      requited: false
    },
    showReload: {
      type: Boolean,
      default: false
    },
    showEdit: {
      type: Boolean,
      default: false
    },
    showSettings: {
      type: Boolean,
      required: false,
      default: false
    },
    showClearButton: {
      type: Boolean,
      default: false
    },
    showClearButtonIcon: {
      type: Boolean,
      default: false
    },
    showSaveButton: {
      type: Boolean,
      default: false
    },
    showSaveButtonIcon: {
      type: Boolean,
      default: false
    },
    hideHead: {
      type: Boolean,
      default: false
    },
    hideFooter: {
      type: Boolean,
      default: false
    },
    showSearchButton: {
      type: Boolean,
      default: false
    },
    showSearchButtonIcon: {
      type: Boolean,
      default: false
    },
    showExportButton: {
      type: Boolean,
      default: false
    },
    showNewButton: {
      type: Boolean,
      default: false
    },
    showBackButton: {
      type: Boolean,
      default: false
    },
    showBackButtonIcon: {
      type: Boolean,
      default: false
    },
    showTipFooter: {
      type: Boolean,
      required: false,
      default: true
    },
    ShowFooterImbo: {
      type: Boolean,
      required: false,
      default: false
    },
    HiddenFooterImbo: {
      type: Boolean,
      required: false,
      default: false
    },
    messageTipFooter: {
      type: String,
      required: false
    },
    messageTypeTipFooter: {
      type: String,
      required: false
    },
    disabledKeyUpEnter: {
      type: Boolean,
      required: false,
      default: true
    },
    showSearchIcon: {
      type: Boolean,
      required: false,
      default: false
    },
    saveButtonText: {
      type: String,
      required: false
    },
    Minimize: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    RequiredFieldBlock
  },
  computed: {
    HasShowForm: function () {
      return this.showForm
    },
    HasMinimize: function () {
      return this.Minimize
    },
    HasHelp: function () {
      return this.showHelp
    },
    HasReload: function () {
      return this.showReload
    },
    HasEdit: function () {
      return this.showEdit
    },
    HasSettings: function () {
      return this.showSettings
    },
    HasButtonClear: function () {
      return this.showClearButton
    },
    HasButtonClearIcon: function () {
      return this.showClearButtonIcon
    },
    HasButtonSave: function () {
      return this.showSaveButton
    },
    HasButtonSaveIcon: function () {
      return this.showSaveButtonIcon
    },
    HasButtonExport: function () {
      return this.showExportButton
    },
    HasButtonSearch: function () {
      return this.showSearchButton
    },
    HasButtonNew: function () {
      return this.showNewButton
    },
    HasButtonBack: function () {
      return this.showBackButton
    },
    HasButtonBackIcon: function () {
      return this.showBackButtonIcon
    },
    HasButtonSearchIcon: function () {
      return this.showSearchButtonIcon
    },
    HasdontShowFooter: function () {
      return this.dontShowFooter
    },
    TextButtonSave: function () {
      return this.saveButtonText ? this.saveButtonText : this.$lang.Common.Buttons.Save
    }
  },
  methods: {
    ClearForm () {
      if (this.HasButtonClear) {
        this.$emit('Clear')
      }
    },
    SaveForm () {
      if (this.HasButtonSave && !this.disabledKeyUpEnter) {
        this.$emit('Save')
      }
    },
    SearchForm () {
      if (this.HasButtonSearch) {
        this.$emit('Search')
      }
    },
    ExportForm () {
      if (this.HasButtonExport) {
        this.$emit('Export')
      }
    },
    changeMinimizado () {
      this.$emit('changeMinizado')
      this.hasMinimizado = !this.hasMinimizado
    },
    ValidateForm () {
      console.log('VALIDAR')
      console.log(this.$children)
      return false
    },
    OnKeyUpEnter () {
      if (this.HasButtonSave && !this.disabledKeyUpEnter) {
        this.$emit('Save')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/Forms.vue